import { render } from "./asyncComponent.vue?vue&type=template&id=45b9811e&ts=true"
import script from "./asyncComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./asyncComponent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/asyncComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45b9811e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45b9811e', __exports__)) {
    api.reload('45b9811e', __exports__)
  }
  
  module.hot.accept("./asyncComponent.vue?vue&type=template&id=45b9811e&ts=true", () => {
    api.rerender('45b9811e', render)
  })

}


export default __exports__